export default __webpack_public_path__ + "static/media/gallery_08.31308a39.jpg";